import React from 'react';
import {Form, Label, Segment, Accordion, TextArea, Button, Dropdown} from 'semantic-ui-react';
import axios from 'axios';
import '../css/QAdminAPI.css'

class QDeleteProductRelease extends React.Component {

    constructor(props) {
        super(props);
        this.state = {product:null, version:null, buildNumber:null, response:null}
        }

    // Sent download link to the user email.
    deleteProductRelease = () => {
        if (!this.state.product){ 
            alert("Please enter a product.")
            return
        }
        if (!this.state.version){ 
            alert("Please define a version.")
            return
            }
        if (!this.state.buildNumber){ 
        alert("Please enter an installer build number.")
        return
        }
        this.setState({response: ""})
        const url = "/admin/delete/" + this.state.product + "/" + this.state.version + "/" + this.state.buildNumber
        const params = {token:this.props.getToken()}
        let result = axios({method: "delete", url:url, params: params})
        result.then((response)=> {this.setState({response: response.data.db_response}); this.props.getProducts()},
                 (error) => {this.setState({response: error.response.data.detail}); this.props.getUser()})

    }

    // Get version Number list of the selected product
    versionNumbers = () => {
        var versions = []
        for (var i=0; i < this.props.products.length; i++) {
            let prod = this.props.products[i]
            if(this.state.product === prod[0]) {
                prod[1].map((release) => versions.push({key:release[0], value:release[0], text:release[0]}))
                break 
        }
        }
        return versions
      }

     // Get build Number list of the selected product and version
    buildNumbers = () => {
        var buildNumbers = []
        for (var i=0; i < this.props.products.length; i++) {
            let prod = this.props.products[i]
            if(this.state.product === prod[0]) {
                let releases = prod[1]
                for (var j=0; j < releases.length; j++) {
                    let release = releases[j]
                    if (this.state.version === release[0]) {
                        release[1].map((build) => buildNumbers.push({key:build[0], value:build[0], text:build[0]}))
                    break
                }
                
        }
        break
        }
        }
        return buildNumbers

    }

    render () {
        return (
            <Segment  className='deleteSegmentStyle'>
            <Accordion.Title 
            active={this.props.activeIndex === this.props.index}
            content= {(
                <>
                <Label className='methodLabel' color='red'> Delete a given version product build exe </Label>
                </>
                )} 
                index={this.props.index}
                onClick={this.props.handleClick}
            />
            <Accordion.Content
            active={this.props.activeIndex === this.props.index} 
            content={(
            <>
            <Form>
                <Form.Field >
                <label>Product</label>
                <Dropdown placeholder='Select product' selection options={this.props.productNames}
                onChange={(event, {name, value}) => this.setState({product: value})}/>
                </Form.Field>
                <Form.Field >
                <label>Version</label>
                <Dropdown placeholder='Select version' selection options={this.versionNumbers()}
                onChange={(event, {name, value}) => this.setState({version: value})}/>
                </Form.Field>
                <Form.Field >
                <label>Build number</label>
                <Dropdown placeholder='Select build number' selection options={this.buildNumbers()}
                onChange={(event, {name, value}) => this.setState({buildNumber: value})}/>
                </Form.Field>
                <Form.Field>
                <Button className="submitBtn" fluid onClick={(e) => this.deleteProductRelease()}>
                Submit
                </Button>
                </Form.Field> 
                <Form.Field>
                <label>Response</label>
                <TextArea value={this.state.response}/>
                </Form.Field>     
            </Form>
            </>
            )} />
            </Segment>
        )
    }

}

export default QDeleteProductRelease